<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>体质报告列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item prop="search">
        <el-input size="small" v-model="formInline.id" auto-complete="off" placeholder="输入报告id"></el-input>
      </el-form-item>
      <el-form-item prop="search" v-if="isSuper">
        <el-input size="small" v-model="formInline.appId" auto-complete="off" placeholder="输入appId"></el-input>
      </el-form-item>
      <el-form-item prop="search">
        <el-input size="small" v-model="formInline.extId" auto-complete="off" placeholder="输入extId"></el-input>
      </el-form-item>
      <el-form-item prop="search">
        <el-date-picker
          size="small"
          v-model="formInline.startTime"
          type="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          placeholder="开始日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="search">
        <el-date-picker
          size="small"
          v-model="formInline.endTime"
          type="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch()">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-collection" @click="handleExport()">导出</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="id" label="ID" width="150">
      </el-table-column>
      <el-table-column prop="createTime" label="报告时间" width="140">
      </el-table-column>
      <el-table-column prop="user.appId" label="应用ID">
      </el-table-column>
      <el-table-column prop="user.extId" label="用户ID">
      </el-table-column>
      <el-table-column prop="user.name" label="姓名"></el-table-column>
      <el-table-column prop="resultTitle" label="体质结果"></el-table-column>
      <el-table-column prop="resultCode" label="体质结果代号"></el-table-column>
      <el-table-column prop="feedbackFlag" label="是否认可">
        <template slot-scope="scope">{{scope.row.feedbackFlag?(scope.row.feedbackFlag===1?'认可':'不认可'):'未反馈'}}</template>
      </el-table-column>
      <el-table-column prop="feedbackDesc" label="反馈内容" show-overflow-tooltip="true"></el-table-column>
      <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" icon="el-icon-search" @click="editBusiness(scope.$index, scope.row)">查看报告</el-button>
        </template>
      </el-table-column>

    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <el-dialog title="查看报告明细" :visible.sync="bfVisible" width="50%" @click="closeBfDialog">
      <div>
        <div style="margin-bottom:20px;">
          <h3 style="text-align: center">用户</h3>
          <p><strong>姓名：</strong>{{result.user.name}}</p>
          <p><strong>年龄：</strong>{{result.user.age}}</p>
          <p><strong>性别：</strong>{{result.user.gender==1?"男":"女"}}</p>
        </div>

        <div style="margin-bottom:20px;">
          <h3 style="text-align: center">体质结果</h3>
          <p><strong style="color:blue">{{result.resultTitle}}</strong></p>
          <p><strong>定义：</strong>{{result.detail.definition}}</p>
          <p><strong>常见不适：</strong>{{result.detail.discomfort}}</p>
          <p><strong>起因：</strong>{{result.detail.caution}}</p>
          <p><strong>穴位：</strong>{{result.detail.acupoint}}</p>
          <p><strong>饮食建议：</strong>{{result.detail.food}}</p>
          <p><strong>运动建议：</strong>{{result.detail.sport}}</p>
        </div>

        <div style="margin-bottom:20px;">
          <h3 style="text-align: center">AI总结</h3>
          <vue-markdown :source="result.aiSummary"></vue-markdown>
        </div>
        <hr/>
        <div style="margin-bottom:20px;">
          <h3 style="text-align: center">AI调理建议</h3>
          <vue-markdown :source="result.aiAdvice"></vue-markdown>
        </div>
        <hr/>
        <div style="margin-bottom:20px;">
          <h3 style="text-align: center">回答内容</h3>
          <table style="width: 100%;border-collapse: collapse;" id="ques-table">
            <thead>
              <td>问题</td>
              <td style="width: 50px">回答</td>
            </thead>
            <tr v-for="q in result.answerList">
              <td>{{q.code}}.{{q.question}}</td>
              <td>{{q.answer}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeBfDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  loadPhysiqueList, physiqueAiAnalyze
} from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  import {getStore} from "../../utils/util";
import VueMarkdown from 'vue-markdown';

export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        bfVisible: false,
        isSuper:parseInt(getStore('isSuper')),
        title: '添加',
        editForm: {
          deptId: '',
          deptName: '',
          deptNo: '',
          token: localStorage.getItem('logintoken')
        },
        result:{
          user:{},
          detail:{}
        },
        businessForm: {},
        // rules表单验证
        rules: {
          tutorName: [{
            required: true,
            message: '导师姓名必填',
            trigger: 'blur'
          }],
          mobile: [{
            required: true,
            message: '必填',
            trigger: 'blur'
          }],
          gender: [{
            required: true,
            message: '必填',
            trigger: 'blur'
          }],
          age: [{
            required: true,
            message: '必填',
            trigger: 'blur'
          }],
          academicTitleCode: [{
            required: true,
            message: '必填',
            trigger: 'blur'
          }],
          departmentCode: [{
            required: true,
            message: '必填',
            trigger: 'blur'
          }],
          introduction: [{
            required: true,
            message: '必填',
            trigger: 'blur'
          }]
        },
        formInline: {
          pageNum: 1,
          pageSize: 10,
          startTime:'',
          endTime:'',
          search:''
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        list: [],
        academicTitleList: [],
        levelList: [],
        jiaowuList: [],
        yiwuList: [],
        acceptTypeList: [],
        schoolList: []

      }
    },
    // 注册组件
    components: {
      Pagination,VueMarkdown
    },

    /**
     * 创建完毕
     */
    created() {
      this.getdata()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      getdata(parameter) {
        this.loading = true
        loadPhysiqueList(parameter)
          .then(res => {
            this.loading = false
            if (res.code !== '0000') {
              this.$message({
                type: 'error',
                message: res.msg
              })
            } else {
              this.listData = res.data.list
              for (let i=0;i<this.listData.length;i++){
                let row = this.listData[i]
                if (!row.aiSummary){
                  row.aiSummary = "暂未生成";
                }
                if (!row.aiAdvice){
                  row.aiAdvice = "暂未生成";
                }
              }
              // 分页赋值
              this.pageparm.currentPage = this.formInline.pageNum
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.data.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('列表加载失败，请稍后再试！')
          })
      },

      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNum = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },

      //显示编辑界面
      handleEdit: function (index, row) {
        window.open(row.reportUrl)
      },
      joinArgs(data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      },
      handleSearch: function(index, row){
        this.formInline.pageNum = 1
        this.getdata(this.formInline)
      },
      handleExport: function (index, row) {
        let url = '/aimed-api/admin/physique/export';
        let args = this.joinArgs(this.formInline)
        window.open(url + '?' + args)
      },
      aiAnalyze: function (row) {
        physiqueAiAnalyze({id:row.id})
          .then(res => {
            if (res.code === '0000') {
              this.$message({
                type: 'success',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('可能网络故障，请稍后再试！')
          })
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            tutorSaveUpdate(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code == 0) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'error',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
      },
      closeBfDialog() {
        this.bfVisible = false;
      },
      editBusiness(index, row) {
        this.bfVisible = true;
        this.result = row
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  #ques-table td{
    border: 1px solid #ccc;
    padding: 5px;

  }
  #ques-table tr{
    border-collapse: collapse;
  }
  #ques-table thead{
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/physique/list.vue